"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BearWorkspaceMeasures = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var api_model_bear_1 = require("@gooddata/api-model-bear");
var flow_1 = tslib_1.__importDefault(require("lodash/flow"));
var map_1 = tslib_1.__importDefault(require("lodash/fp/map"));
var replace_1 = tslib_1.__importDefault(require("lodash/fp/replace"));
var uniq_1 = tslib_1.__importDefault(require("lodash/fp/uniq"));
var MetaConverter_1 = require("../../../convertors/fromBackend/MetaConverter");
var MetricConverter_1 = require("../../../convertors/fromBackend/MetricConverter");
var MetricConverter_2 = require("../../../convertors/toBackend/MetricConverter");
var api_1 = require("../../../utils/api");
var measureExpressionTokens_1 = require("./measureExpressionTokens");
var VisualizationConverter_1 = require("../../../convertors/fromBackend/VisualizationConverter");
var BearWorkspaceMeasures = /** @class */ (function () {
    function BearWorkspaceMeasures(authCall, workspace) {
        this.authCall = authCall;
        this.workspace = workspace;
    }
    BearWorkspaceMeasures.prototype.getMeasureExpressionTokens = function (ref) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var uri, metricMetadata, expressionTokens, expressionIdentifiers, expressionUris, expressionElementUris, expressionIdentifierUrisPairs, expressionIdentifierUris, allExpressionElementAttributeUris, allExpressionUris, allExpressionWrappedObjects, allExpressionObjects, allExpressionAttributeElements, objectsByUri, objectsByIdentifier, attributeElementsByUri;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_1.objRefToUri(ref, this.workspace, this.authCall)];
                    case 1:
                        uri = _a.sent();
                        return [4 /*yield*/, this.authCall(function (sdk) {
                                return sdk.xhr.getParsed(uri);
                            })];
                    case 2:
                        metricMetadata = _a.sent();
                        if (!api_model_bear_1.GdcMetadata.isWrappedMetric(metricMetadata)) {
                            throw new Error("To get measure expression tokens, provide the correct measure identifier. Did you provide a measure identifier?");
                        }
                        expressionTokens = measureExpressionTokens_1.tokenizeExpression(metricMetadata.metric.content.expression);
                        expressionIdentifiers = measureExpressionTokens_1.getTokenValuesOfType("identifier", expressionTokens);
                        expressionUris = measureExpressionTokens_1.getTokenValuesOfType("uri", expressionTokens);
                        expressionElementUris = measureExpressionTokens_1.getTokenValuesOfType("element_uri", expressionTokens);
                        return [4 /*yield*/, this.authCall(function (sdk) {
                                return sdk.md.getUrisFromIdentifiers(_this.workspace, expressionIdentifiers);
                            })];
                    case 3:
                        expressionIdentifierUrisPairs = _a.sent();
                        expressionIdentifierUris = expressionIdentifierUrisPairs.map(function (pair) { return pair.uri; });
                        allExpressionElementAttributeUris = flow_1.default(map_1.default(replace_1.default(/\/elements\?id=.*/, "")), uniq_1.default)(expressionElementUris);
                        allExpressionUris = uniq_1.default(tslib_1.__spreadArrays(expressionUris, expressionIdentifierUris, allExpressionElementAttributeUris));
                        return [4 /*yield*/, this.authCall(function (sdk) {
                                return sdk.md.getObjects(_this.workspace, allExpressionUris);
                            })];
                    case 4:
                        allExpressionWrappedObjects = _a.sent();
                        allExpressionObjects = allExpressionWrappedObjects.map(api_model_bear_1.GdcMetadataObject.unwrapMetadataObject);
                        return [4 /*yield*/, Promise.all(expressionElementUris.map(function (elementUri) {
                                return _this.authCall(function (sdk) { return sdk.md.getAttributeElementDefaultDisplayFormValue(elementUri); });
                            }))];
                    case 5:
                        allExpressionAttributeElements = _a.sent();
                        objectsByUri = allExpressionObjects.reduce(function (acc, el) {
                            var _a;
                            return tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[el.meta.uri] = el, _a));
                        }, {});
                        objectsByIdentifier = allExpressionObjects.reduce(function (acc, el) {
                            var _a;
                            return tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[el.meta.identifier] = el, _a));
                        }, {});
                        attributeElementsByUri = allExpressionAttributeElements.reduce(function (acc, el) {
                            var _a;
                            if (!el) {
                                return acc;
                            }
                            return tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[el.uri] = el, _a));
                        }, {});
                        return [2 /*return*/, expressionTokens.map(function (token) {
                                if (token.type === "element_uri") {
                                    return createAttribute(attributeElementsByUri, token);
                                }
                                if (token.type === "uri" || token.type === "identifier") {
                                    return createIdentifier(token, objectsByUri, objectsByIdentifier);
                                }
                                if (token.type === "comment" ||
                                    token.type === "number" ||
                                    token.type === "quoted_text" ||
                                    token.type === "text" ||
                                    token.type === "bracket") {
                                    return createToken(token.type, token.value);
                                }
                                return createToken("text", token.value);
                            })];
                }
            });
        });
    };
    BearWorkspaceMeasures.prototype.createMeasure = function (measure) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var mdObject;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authCall(function (sdk) {
                            return sdk.md.createObject(_this.workspace, { metric: MetricConverter_2.convertMetricToBackend(measure) });
                        })];
                    case 1:
                        mdObject = _a.sent();
                        return [2 /*return*/, MetricConverter_1.convertMetricFromBackend(mdObject.metric)];
                }
            });
        });
    };
    BearWorkspaceMeasures.prototype.deleteMeasure = function (ref) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var uri;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_1.objRefToUri(ref, this.workspace, this.authCall)];
                    case 1:
                        uri = _a.sent();
                        return [4 /*yield*/, this.authCall(function (sdk) { return sdk.md.deleteObject(uri); })];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BearWorkspaceMeasures.prototype.updateMeasure = function (measure) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var objectId;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        objectId = measure.uri.split("/").slice(-1)[0];
                        return [4 /*yield*/, this.authCall(function (sdk) {
                                return sdk.md.updateObject(_this.workspace, objectId, { metric: MetricConverter_2.convertMetricToBackend(measure) });
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, measure];
                }
            });
        });
    };
    BearWorkspaceMeasures.prototype.getMeasureReferencingObjects = function (ref) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var uri, data;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api_1.objRefToUri(ref, this.workspace, this.authCall)];
                    case 1:
                        uri = _a.sent();
                        return [4 /*yield*/, this.authCall(function (sdk) {
                                return sdk.md.getObjectUsedBy(_this.workspace, uri, {
                                    types: ["metric", "visualizationObject"],
                                    nearest: true,
                                });
                            })];
                    case 2:
                        data = _a.sent();
                        return [2 /*return*/, Promise.resolve({
                                measures: data.filter(function (item) { return item.category === "metric"; }).map(MetricConverter_1.convertListedMetric),
                                insights: data
                                    .filter(function (item) { return item.category === "visualizationObject"; })
                                    .map(VisualizationConverter_1.convertListedVisualization),
                            })];
                }
            });
        });
    };
    return BearWorkspaceMeasures;
}());
exports.BearWorkspaceMeasures = BearWorkspaceMeasures;
function createAttribute(attributeElementsByUri, token) {
    var element = attributeElementsByUri[token.value];
    return tslib_1.__assign({ type: "attributeElement" }, (element
        ? {
            value: element.title,
        }
        : {
            value: "",
            deleted: true,
        }));
}
function createIdentifier(token, objectsByUri, objectsByIdentifier) {
    var meta = token.type === "uri"
        ? MetaConverter_1.convertMetadataObject(objectsByUri[token.value])
        : MetaConverter_1.convertMetadataObject(objectsByIdentifier[token.value]);
    return {
        type: meta.type,
        value: meta.title,
        id: meta.id,
        ref: meta.ref,
    };
}
function createToken(type, value) {
    return {
        type: type,
        value: value,
    };
}
//# sourceMappingURL=index.js.map